import React, { useState } from 'react';
import { collection, doc, setDoc } from 'firebase/firestore';
import { db } from '../firebase/config';

const DataImport = () => {
  const [status, setStatus] = useState('');
  const [isUploading, setIsUploading] = useState(false);

  const tredesData = {
    "vertrouwen": {
      "name": "Vertrouwen",
      "subtitle": "De basis voor elke relatie: kwetsbaarheid en openheid",
      "questions": [
        { "text": "Wij delen openlijk onze fouten en zwakheden met elkaar", "type": "scale" },
        { "text": "Wij vragen om hulp zonder angst voor oordeel", "type": "scale" },
        { "text": "We geven elkaar opbouwende feedback", "type": "scale" },
        { "text": "We voelen ons veilig om risico's te nemen", "type": "scale" },
        {
          "text": "Iemand maakt een kostbare fout. Hoe reageer je?",
          "type": "scenario",
          "options": [
            { "text": "Zoeken naar een schuldige en wijzen met de vinger", "value": 1 },
            { "text": "Stilzwijgend accepteren maar er later over roddelen", "value": 2 },
            { "text": "Samen kijken naar wat er mis ging en hoe het beter kan", "value": 4 },
            { "text": "Ondersteunen, leren van de fout en samen oplossingen zoeken", "value": 5 }
          ]
        }
      ]
    },
    "conflicten": {
      "name": "Conflicten",
      "subtitle": "Productieve discussies zonder persoonlijke aanvallen",
      "questions": [
        { "text": "We hebben levendige discussie over belangrijke onderwerpen", "type": "scale" },
        { "text": "We waarderen en bespreken verschillende meningen", "type": "scale" },
        { "text": "We pakken conflicten meteen aan, we vermijden ze niet.", "type": "scale" },
        { "text": "We maken onderscheid tussen ideologische en persoonlijke conflicten", "type": "scale" },
        {
          "text": "We krijgen tijdens het eten een heftige discussie. Wat gebeurt er?",
          "type": "scenario",
          "options": [
            { "text": "Iemand stopt de discussie om \"de vrede te bewaren\"", "value": 1 },
            { "text": "Mensen trekken zich terug en zeggen niets meer", "value": 2 },
            { "text": "We zetten de discussie voort met focus op de inhoud", "value": 4 },
            { "text": "We discussiëren gepassioneerd met respect voor alle standpunten", "value": 5 }
          ]
        }
      ]
    },
    "betrokkenheid": {
      "name": "Commitment",
      "subtitle": "Iedereen houdt zich aan  beslissingen en duidelijke afspraken",
      "questions": [
        { "text": "Iedereen is betrokken bij het nemen van belangrijke beslissingen", "type": "scale" },
        { "text": "Eenmaal genomen beslissingen worden door iedereen gesteund", "type": "scale" },
        { "text": "We hebben duidelijke afspraken over doelen en prioriteiten", "type": "scale" },
        { "text": "Onduidelijkheden worden direct uitgesproken en opgelost", "type": "scale" },
        {
          "text": "We hebben beslissing genomen waar niet iedereen het mee eens was. Hoe gaan we hier als gezin mee om?",
          "type": "scenario",
          "options": [
            { "text": "Tegenstanders blijven achter de schermen tegenwerken", "value": 1 },
            { "text": "Er wordt halfhartig meegewerkt met de beslissing", "value": 2 },
            { "text": "Iedereen houdt zich aan de afspraak, ook al waren ze het er niet mee eens", "value": 4 },
            { "text": "Iedereen steunt de beslissing volledig en werkt samen aan de uitvoering", "value": 5 }
          ]
        }
      ]
    },
    "verantwoording": {
      "name": "Verantwoordelijkheid",
      "subtitle": "Verantwoordelijkheid nemen voor eigen gedrag en anderen aanspreken op hun gedrag",
      "questions": [
        { "text": "We spreken elkaar aan op gedrag dat het gezin schaadt", "type": "scale" },
        { "text": "We houden elkaar verantwoordelijk voor afspraken", "type": "scale" },
        { "text": "We durven eerlijk te kijken naar ons eigen en elkaars gedrag", "type": "scale" },
        { "text": "Er wordt actie ondernomen als er schadelijk gedrag is", "type": "scale" },
        {
          "text": "Een van ons komt consequent afspraken niet na. Hoe reageren we?",
          "type": "scenario",
          "options": [
            { "text": "Iedereen klaagt erover maar niemand doet iets", "value": 1 },
            { "text": "Het is altijd dezelfde persoon die hier wat van zegt", "value": 2 },
            { "text": "We spreken elkaar direct aan op het gedrag", "value": 4 },
            { "text": "We bespreken samen open hoe het voor iedereen is en zoeken naar een oplossing", "value": 5 }
          ]
        }
      ]
    },
    "resultaten": {
      "name": "Resultaten",
      "subtitle": "Collectieve focus op gezamenlijke belangen boven individuele belangen",
      "questions": [
        { "text": "Gezamenlijke resultaten gaan boven individuele resultaten", "type": "scale" },
        { "text": "Iedereen draagt bij aan het gezamenlijk belang", "type": "scale" },
        { "text": "Wij vieren gezamenlijk successen", "type": "scale" },
        { "text": "Individuele ego's worden opzij gezet voor het gezamenlijke belang", "type": "scale" },
        {
          "text": "Een van ons krijgt een aanbod wat ons gezamenlijke belang negatief kan beïnvloeden. (bv werk, huisvesting, etc)",
          "type": "scenario",
          "options": [
            { "text": "diegene doet het en houdt geen rekening met negatieve consequenties voor het geheel", "value": 1 },
            { "text": "Diegene doet het niet en houdt geen rekening met de negatieve consequenties voor hem/haar/het zelf", "value": 2 },
            { "text": "Diegene bespreekt het met de anderen en we proberen samen een compromis te vinden", "value": 4 },
            { "text": "We bespreken het en komen tot een situatie waar we allemaal voordeel van hebben.", "value": 5 }
          ]
        }
      ]
    }
  };

  const uploadTredes = async () => {
    setIsUploading(true);
    setStatus('Uploaden gestart...');

    try {
      const tredeKeys = Object.keys(tredesData);
      
      for (let i = 0; i < tredeKeys.length; i++) {
        const key = tredeKeys[i];
        const data = tredesData[key];
        
        setStatus(`Uploaden trede ${i + 1}/${tredeKeys.length}: ${data.name}...`);
        
        await setDoc(doc(db, 'tredes', key), data);
        
        console.log(`✅ Uploaded: ${key}`);
      }

      setStatus('✅ SUCCES! Alle 5 tredes met 25 vragen zijn geüpload naar Firestore!');
      
    } catch (error) {
      console.error('Error uploading tredes:', error);
      setStatus(`❌ ERROR: ${error.message}`);
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div style={{ padding: '40px', maxWidth: '800px', margin: '0 auto' }}>
      <h1>Piramide Scan - Vragen Importeren</h1>
      
      <div style={{ 
        background: '#f0f9ff', 
        padding: '20px', 
        borderRadius: '8px',
        marginBottom: '20px'
      }}>
        <h3>Wat doet dit script?</h3>
        <ul>
          <li>Upload 5 tredes naar Firestore</li>
          <li>Per trede: 4 schaalvragen + 1 scenariovraag</li>
          <li>Totaal: 25 vragen</li>
          <li>Collection: <code>tredes</code></li>
        </ul>
      </div>

      {status && (
        <div style={{
          padding: '15px',
          background: status.includes('ERROR') ? '#fee' : status.includes('SUCCES') ? '#efe' : '#fff3cd',
          border: '1px solid',
          borderColor: status.includes('ERROR') ? '#fcc' : status.includes('SUCCES') ? '#cfc' : '#ffd700',
          borderRadius: '4px',
          marginBottom: '20px'
        }}>
          {status}
        </div>
      )}

      <button
        onClick={uploadTredes}
        disabled={isUploading}
        style={{
          padding: '12px 24px',
          fontSize: '16px',
          background: isUploading ? '#ccc' : '#4CAF50',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: isUploading ? 'not-allowed' : 'pointer'
        }}
      >
        {isUploading ? 'Bezig met uploaden...' : '🚀 Upload Vragen naar Firestore'}
      </button>

      <div style={{ marginTop: '30px', fontSize: '14px', color: '#666' }}>
        <p><strong>Na succesvol uploaden:</strong></p>
        <ol>
          <li>Check Firebase Console → Firestore Database → Collection "tredes"</li>
          <li>Test de scan in de app</li>
          <li>Verwijder dit import component (niet meer nodig)</li>
        </ol>
      </div>
    </div>
  );
};

export default DataImport;